// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-default-layout{max-width:1920px;margin-top:var(--viewport-offset-top);margin-left:auto;margin-right:auto}.h-default-layout__overlay{z-index:calc(var(--z-index-header) - 1);position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.5)}", ""]);
// Exports
module.exports = exports;
